{
  "nl": {
    "milestone": {
      "actions": {
        "activate": "Activeer",
        "activate_phase": "Deze fase activeren",
        "complete_phase": "Deze fase afronden",
        "create": "Fase aanmaken",
        "delete": "Verwijder",
        "delete_milestones": "Fase verwijderen | {count} fases verwijderen",
        "move_down": "Fase omlaag",
        "move_unit_back": "Unit terugzetten naar hier",
        "move_up": "Fase omhoog",
        "new": "Fase",
        "reactivate_phase": "Deze fase heractiveren"
      },
      "activate": {
        "body": "Alle items van deze fase worden gepubliceerd voor deze unit en de toegewezenen krijgen een melding.",
        "body_empty": "Maakt niets zichtbaar voor de klant.",
        "body_intermediate": "Tussenliggende fases worden mee afgerond en alle items die eraan hangen worden ook gepubliceerd.",
        "body_project": "Alle items van deze fase worden gepubliceerd voor dit project en de toegewezenen krijgen een melding.",
        "body_reactivate": "Deze fase wordt opnieuw de huidige fase. Er wordt niets ingetrokken: alles wat al gepubliceerd of verstuurd is, blijft staan. De fases erna worden weer gepland.",
        "confirm": "Activeer",
        "confirm_publish": "Activeren en versturen",
        "confirm_reactivate": "Heractiveren",
        "past_warning": "Teruggaan naar een eerdere fase maakt eerdere acties niet ongedaan. Alles wat met klanten is gedeeld, wordt niet automatisch ingetrokken.",
        "title": "Fase activeren",
        "title_activate": "“{name}” activeren?",
        "title_reactivate": "“{name}” heractiveren?",
        "verb_default": "Trigger",
        "verb_share": "Deel"
      },
      "assign": {
        "body": "De units die je selecteert gaan naar “{to}”. De items van “{to}” en van elke fase die ze overslaan worden zichtbaar voor de klant en de toegewezenen krijgen een melding.",
        "body_phases_only": "De units die je selecteert gaan naar “{to}”. De klant ziet de nieuwe fase.",
        "excluded": "Units die al op of voorbij “{to}” staan, kun je niet selecteren."
      },
      "attach": {
        "add": "Toevoegen",
        "add_and_move": "Toevoegen en verhuizen",
        "assigned_tag": "Toegewezen",
        "back": "Terug",
        "counts": "{available} beschikbaar · {assigned} reeds toegewezen",
        "description_decision": "Keuzes die de klant moet maken",
        "description_survey": "Vragenlijsten om input te verzamelen",
        "description_todo": "Taken die de klant moet afronden",
        "elsewhere_tag": "Nu op {name}",
        "empty": "Geen items beschikbaar",
        "empty_state_description": "Op basis van je abonnement kun je {kinds} toevoegen aan deze fase.",
        "intro": "Kies welke soort item je wilt koppelen aan deze fase.",
        "move_notice_body": "Wat al verstuurd is, blijft verstuurd. De oude fase verliest dit item.",
        "move_notice_item": "{element}, nu op {phase}",
        "move_notice_title": "Dit item verhuist naar “{name}” | Deze items verhuizen naar “{name}”",
        "next": "Volgende",
        "search": "Zoeken",
        "select_intro": "Selecteer de {kind} die je wilt toevoegen.",
        "subtitle": "Aan fase: {name}",
        "success": "Items toegevoegd",
        "title": "Items toevoegen"
      },
      "complete_phase": {
        "body": "Deze unit rondt deze fase af en heeft daarna geen actieve fase meer. | {count} units ronden deze fase af en hebben daarna geen actieve fase meer.",
        "body_sup": "Dit project rondt deze fase af en heeft daarna geen actieve fase meer.",
        "confirm": "Fase afronden",
        "keep": "Fase actief houden",
        "title": "“{name}” afronden?"
      },
      "delete_phase": {
        "body": "Units die nu op deze fase staan, hebben daarna geen actieve fase meer. Ze gaan niet naar de vorige of volgende stap. De items van deze fase worden losgemaakt, niet verwijderd. Items die al aan een unit gepubliceerd zijn, blijven gepubliceerd: die verwijder je bij de unit zelf.",
        "body_last": "Units die nu op deze fase staan, hebben daarna geen actieve fase meer. Omdat dit de laatste fase is, tellen ze dan als afgerond. De items van deze fase worden losgemaakt, niet verwijderd. Items die al aan een unit gepubliceerd zijn, blijven gepubliceerd: die verwijder je bij de unit zelf.",
        "body_sup": "Dit project heeft daarna geen actieve fase meer. Het gaat niet naar de vorige of volgende stap. De items van deze fase worden losgemaakt, niet verwijderd. Items die al gepubliceerd zijn, blijven gepubliceerd: die verwijder je bij het project zelf.",
        "confirm": "Fase verwijderen",
        "keep": "Fase behouden",
        "title": "“{name}” verwijderen?"
      },
      "detach": {
        "body": "Dit haalt het item van deze fase. Het item zelf blijft bestaan en units die het al zagen, houden het. Nieuwe units krijgen het niet meer bij deze fase.",
        "confirm": "Losmaken",
        "keep": "Behouden",
        "title": "“{name}” losmaken?"
      },
      "filters": {
        "clear": "Alle filters wissen",
        "done": "Klaar",
        "group_milestones": "Fases",
        "group_status": "Status",
        "group_title": "Inhoud fase",
        "no_phase": "Geen fase",
        "no_units_here": "Geen units hier",
        "nothing_assigned": "Niets toegewezen",
        "phase_last": "Op laatste fase",
        "since_month_over": "Langer dan een maand",
        "since_quarter_over": "Langer dan 3 maanden",
        "since_two_weeks_over": "Langer dan 2 weken",
        "title": "Filters",
        "units_here": "Heeft units hier"
      },
      "labels": {
        "add_element": "Item toevoegen",
        "added_ago": "{duration} geleden toegevoegd",
        "assign_units": "Units toewijzen",
        "assigned_count": "0 toegewezen | 1 toegewezen | {count} toegewezen",
        "assigned_elements": "Toegewezen items",
        "assigned_empty_description": "Koppel {kinds} aan deze fase",
        "assigned_empty_title": "Nog geen items",
        "bulk_assign_title": "Selecteer units waaraan je fase '{milestone_name}' wilt toewijzen",
        "complete_units": "Rond {count} unit af | Rond {count} units af",
        "completed_subtitle": "Deze units hebben de workflow doorlopen",
        "completed_title": "Afgerond",
        "detach": "Losmaken",
        "detach_element": "{name} losmaken",
        "drag_to_reorder": "Sleep om te herschikken",
        "edit_milestone": "Fase bewerken",
        "element_count": "{count} item | {count} items",
        "elements_assign_link": "Wijs items toe in Mijlpalen",
        "elements_empty": "Er zijn nog geen items aan deze fase toegewezen.",
        "elements_visible": "{elements} zichtbaar voor de klant",
        "empty_state_subtitle": "Fases maken het bouwproces transparanter voor woningkopers",
        "empty_state_title": "Maak een nieuwe fase aan",
        "kind_decision": "Beslissing | Beslissingen",
        "kind_decision_count": "{count} keuze | {count} keuzes",
        "kind_survey": "Enquête | Enquêtes",
        "kind_survey_count": "{count} enquête | {count} enquêtes",
        "kind_todo": "Taak | Taken",
        "kind_todo_count": "{count} taak | {count} taken",
        "locked_not_sent": "{count} element is vergrendeld door je pakket en wordt niet verstuurd. | {count} elementen zijn vergrendeld door je pakket en worden niet verstuurd.",
        "locked_tooltip": "Niet inbegrepen in je huidige pakket. Dit wordt niet naar klanten verstuurd.",
        "milestone": "Fase",
        "milestone_current": "Huidige fase",
        "milestone_name": "Naam van fase",
        "move_units_to": "Verplaats {count} unit naar {name} | Verplaats {count} units naar {name}",
        "new_milestone": "Nieuwe fase",
        "no_phase": "Geen fase",
        "no_results": "Geen fases gevonden",
        "please_select": "Selecteer een nieuwe fase",
        "position": "Positie",
        "progress": "Voortgang",
        "publishes_empty": "Nog niets toegewezen",
        "publishes_summary": "Maakt {elements} zichtbaar voor de klant",
        "reorder_filtered": "Wis de zoekopdracht of filter om fases te herschikken",
        "search_empty_state": "Nog geen fases aangemaakt. Klik hier om te starten",
        "search_phase": "Fase zoeken",
        "search_unit": "Unit zoeken",
        "search_units": "Units zoeken",
        "since": "Sinds",
        "started_on": "Gestart op {date}",
        "status_active": "Bezig",
        "status_completed": "Afgerond",
        "status_planned": "Gepland",
        "unit_active_since": "Bezig sinds {date}",
        "unit_completed_on": "Afgerond {date}",
        "unit_timeline_empty": "Er zijn nog geen fases aangemaakt voor dit project.",
        "units": "Units",
        "units_completed": "Geen units afgerond | 1 unit afgerond | {count} units afgerond",
        "units_empty": "Nog geen units hebben deze fase bereikt.",
        "units_here": "Geen units hier | 1 unit hier | {count} units hier",
        "units_no_results": "Geen units gevonden",
        "units_without_milestone": "1 unit zonder fase | {count} units zonder fase",
        "unstarted_subtitle": "Deze units hebben geen actieve fase",
        "unstarted_title": "Niet in een fase",
        "warning_delete": "Als u een fase verwijdert die aan een unit is toegewezen zal deze klant geen fases meer zien. Zorg ervoor dat u een nieuwe fase toewijst aan deze units!"
      },
      "move": {
        "body": "Deze unit gaat van “{from}” naar “{to}”. De items van “{to}” worden zichtbaar voor de klant en de toegewezenen krijgen een melding. | Deze units gaan van “{from}” naar “{to}”. De items van “{to}” worden zichtbaar voor de klant en de toegewezenen krijgen een melding.",
        "body_phases_only": "Deze unit gaat van “{from}” naar “{to}”. De klant ziet de nieuwe fase. | Deze units gaan van “{from}” naar “{to}”. De klant ziet de nieuwe fase.",
        "confirm": "Verplaatsen en verwittigen",
        "confirm_phases_only": "Verplaatsen",
        "elements": "Maakt {elements} zichtbaar voor de klant",
        "elements_empty": "Maakt niets zichtbaar voor de klant",
        "title": "{count} unit verplaatsen naar “{name}”? | {count} units verplaatsen naar “{name}”?"
      },
      "overview": {
        "no_phase": "Geen fase",
        "not_started": "Niet gestart",
        "since_date": "Sinds {date}",
        "step_of": "Stap {step} van {total}"
      },
      "publication_failed": {
        "body": "Het versturen van de items van deze fase is mislukt voor 1 unit. | Het versturen van de items van deze fase is mislukt voor {count} units.",
        "retried": "De items worden opnieuw verstuurd",
        "retry": "Opnieuw versturen"
      },
      "reorder": {
        "body_earlier": "Deze fase vroeger zetten trekt niets terug wat al gepubliceerd is. Units houden wat ze hebben; enkel de volgorde verandert.",
        "body_earlier_sup": "Deze fase vroeger zetten trekt niets terug wat al gepubliceerd is. Het project houdt wat het heeft; enkel de volgorde verandert.",
        "body_later": "Deze fase later zetten trekt niets terug wat al gepubliceerd is. Units houden wat ze hebben; enkel de volgorde verandert.",
        "body_later_sup": "Deze fase later zetten trekt niets terug wat al gepubliceerd is. Het project houdt wat het heeft; enkel de volgorde verandert.",
        "body_passed": "Units die op een latere fase staan, passeren deze fase nu. Alles wat eraan hangt, wordt meteen aan hen gepubliceerd.",
        "body_passed_sup": "Dit project passeert deze fase nu. Alles wat eraan hangt, wordt meteen gepubliceerd.",
        "body_passes": "Units die op deze fase staan, passeren de fases ertussen nu. Alles wat aan die fases hangt, wordt meteen aan hen gepubliceerd.",
        "body_passes_sup": "Dit project passeert de fases ertussen nu. Alles wat aan die fases hangt, wordt meteen gepubliceerd.",
        "confirm": "Fase verplaatsen",
        "count": "{count} unit passeert {phases} in één keer | {count} units passeren {phases} in één keer",
        "count_sup": "Dit project passeert {phases} in één keer",
        "crossed": "{name} ({elements})",
        "nothing": "niets",
        "phases": "{count} fase | {count} fases",
        "title": "“{name}” na “{previous}” plaatsen?",
        "title_first": "“{name}” vooraan plaatsen?"
      },
      "toasts": {
        "bulk_assigned": "De fase is succesvol toegewezen aan de geselecteerde units",
        "create_success": "Fase succesvol aangemaakt",
        "deleted": "Fase verwijderd",
        "phase_without_units": "Er staan geen units meer op deze fase",
        "sup_assigned": "De fase is succesvol geactiveerd",
        "sup_completed": "Fase afgerond",
        "units_completed": "{count} unit afgerond | {count} units afgerond",
        "units_moved": "{count} unit verplaatst | {count} units verplaatst",
        "update_success": "Fases zijn succesvol bijgewerkt"
      },
      "validation": {
        "needName": "Naam is verplicht",
        "needNamePrimary": "De naam in de primaire taal ({language}) is verplicht"
      }
    }
  }
}
